import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { UserService } from '../../shared/user.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { Login } from '../../shared/user.model';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  showLodingSpinner: boolean;
  formSubmitted: boolean;
  @Output() change = new EventEmitter();
  isLoginError: boolean = false;

  constructor(private userService: UserService, private router: Router) {
    this.formSubmitted = false;
    this.showLodingSpinner = false;
  }

  ngOnInit() {
  }

  Login(form: NgForm) {
    if (!form.invalid) {
      this.showLodingSpinner = true;
      this.userService.userAuthentication(form.value)
        .subscribe((data: any) => {
          localStorage.setItem('accessToken', data.access_token);
          localStorage.setItem('userName', data.userName);
          this.GetAllowedPages();
        },
          (err: HttpErrorResponse) => {
            this.isLoginError = true;
            this.showLodingSpinner = false;
            alert("Username or password is not correct");
          });
    } else
      this.formSubmitted = true;
  }

  GetAllowedPages() {
    this.userService.getAllowedPages()
      .subscribe((data: any) => {
        localStorage.setItem('menuList', JSON.stringify(data));
        this.change.emit(false);
        if (data.length > 0)
          this.router.navigate([data[0].KM_Redirect_URL]);
      },
        (err: HttpErrorResponse) => {
          alert("Failed!");
        });
  }
}




// WEBPACK FOOTER //
// ./src/app/registration/login/login.component.ts